export enum AcctPartyRole {
  BillToB = 'B',
  BillTo = 'BillTo',
  PickupDeliveryP = 'P',
  PickupDelivery = 'PickupDelivery',
}
